import { css } from "@emotion/css";
import classNames from "classnames";
import * as React from "react";
// import styles from "./templateName.module.less";
interface TemplateNameProps {
    name: string;
    truncateName: boolean | undefined;
}
export function TemplateName({ name, truncateName }: TemplateNameProps) {
    return (<div className={truncateName ? classNames(styles.name, styles.truncateName) : styles.name} title={name}>
            {name}
        </div>);
}
const styles = {
    name: css({
        fontFamily: "monospace",
        maxWidth: "100%",
        wordBreak: "break-word",
    }),
    truncateName: css({
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
    }),
};
